module.exports = __webpack_public_path__ + "static/media/servico-toque.04f12de5.png";